import { render } from "./landingServices.vue?vue&type=template&id=ce485db8&scoped=true"
import script from "./landingServices.vue?vue&type=script&lang=js"
export * from "./landingServices.vue?vue&type=script&lang=js"

import "./landingServices.vue?vue&type=style&index=0&id=ce485db8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce485db8"]])

export default __exports__